import React from 'react';
import PropTypes from 'prop-types';
import ChunkedUploadFile from '../Shared/ChunkedUploadFile';
import './ModeratorUploadFile.css';

const MODERATOR_ROOT =
  process.env.REACT_APP_MODERATOR_START_PATH || '/moderator';

function ModeratorUploadFile({ currentPath, userId, onFileUploaded }) {
  return (
    <ChunkedUploadFile
      currentPath={currentPath}
      userId={userId}
      onFileUploaded={onFileUploaded}
      rootPath={MODERATOR_ROOT}
      sessionPrefix="moderator_file"
    />
  );
}

ModeratorUploadFile.propTypes = {
  currentPath: PropTypes.string,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onFileUploaded: PropTypes.func,
};

export default ModeratorUploadFile;
